module.exports = __webpack_public_path__ + "static/gallery_west_street_2_thumb-1e78ce3dcccd30fc32fff1f3fe81a764.jpg";